import { EventScheduleAdditionState } from 'src/app/shared/services/events/schedule-additions/schedule-additions.state';

export const defaultScheduleAdditionsState: EventScheduleAdditionState = {
  getScheduleAdditionsInflight: false,
  createScheduleAdditionInflight: false,
  updateScheduleAdditionInflight: false,
  deleteScheduleAdditionInflight: false
};
